import { Link } from "react-router-dom";
import { NETWORK, NAV } from "../data/content";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="border-t border-border bg-background pt-24 pb-12 px-6 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-6">
            <img
              src={NETWORK.logo}
              alt="EKG Network"
              className="w-16 h-16 rounded-full object-cover ring-1 ring-secondary/40 mb-6"
            />
            <p className="overline text-secondary mb-6">Est. {NETWORK.established}</p>
            <h3 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] text-foreground max-w-xl">
              Ascend<br />Together
            </h3>
            <p className="font-editorial italic text-2xl text-muted-foreground mt-8 max-w-md">
              “{NETWORK.scripture}”
            </p>
            <p className="overline text-secondary mt-4">— {NETWORK.scriptureRef}</p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-muted-foreground mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="font-body text-foreground hover:text-secondary transition-colors duration-300"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/admin/login"
                  data-testid="footer-admin-link"
                  className="font-body text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-muted-foreground mb-6">Connect</p>
            <ul className="space-y-3 font-body text-muted-foreground">
              <li>
                <a href={`mailto:${NETWORK.email}`} className="text-foreground hover:text-secondary transition-colors">
                  {NETWORK.email}
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-foreground hover:text-secondary transition-colors">
                  Submit a Prayer Request
                </Link>
              </li>
              <li>
                <Link to="/summit" className="text-foreground hover:text-secondary transition-colors">
                  Register for the Summit
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4">
          <p className="overline text-muted-foreground text-[0.65rem]">
            © {new Date().getFullYear()} {NETWORK.name}
          </p>
          <p className="overline text-secondary/60 text-[0.65rem]">{NETWORK.seal}</p>
        </div>
      </div>
    </footer>
  );
}
